import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { CardContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FindUserDetails from "../components/FindUserDetails";
import { isEmpty } from "lodash";

const FindEmployee = (props) => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    document.title = "IPPIS - Find Employee";
  });
  const { user } = props;
  const theme = useTheme();
  useEffect(() => {
    if (
      !isEmpty(user) &&
      !user.employments.find(
        ({ positionId }) => positionId === "2000000000-010100000000000000-00041"
      ) &&
      location.pathname.includes("/employees/find-employee-details")
    )
      return history.push("/unauthorized");
  }, [user]);

  return (
    <>
      <div className="ml-5 mr-5">
        <Box>
          <AppBar
            position="static"
            elevation={0}
            style={{ overflow: "hidden" }}
            className="app-bar w-100"
          >
            <Toolbar className="row">
              <div className="col-lg-12">
                <Typography variant="h6" noWrap component="div">
                  <span>FIND EMPLOYEE</span>
                </Typography>
              </div>
            </Toolbar>
          </AppBar>
          <div
            style={{
              padding: theme.spacing(0.4),
              height: "auto",
              maxHeight: "auto",
              margin: "1.2em",
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              overflow: "visible",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            }}
          >
            <CardContent
              style={{
                padding: ".1em",
                height: "auto",
                minHeight: "auto",
                overflow: "auto",
              }}
            >
              <FindUserDetails
                canVerifyProfile={false}
                canGiveAccess={false}
                canEditProfile={false}
              />
            </CardContent>
          </div>
        </Box>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => {
  return {
    user,
  };
};

export default connect(mapStateToProps, {})(FindEmployee);
